import CryptoJS from 'crypto-js';


const key = 'egoal159egoal258egoal357egoal456';// 32位,必须与后端一致  if (key.Length < 32) key = key.PadRight(32, ' ');
// 偏移量 16位（不可随意修改，否则前后端加密解密可能失败） byte[] IV = { 0x41, 0x72, 0x65, 0x79, 0x6F, 0x75, 0x6D, 0x79, 0x53, 0x6E, 0x6F, 0x77, 0x6D, 0x61, 0x6E, 0x3F }
const iv = 'AreyoumySnowman?';

export function  aesEncrypt(data) {
    var enData = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString()
    return Buffer(enData).toString('base64');
}


export function  aesDecrypt(base64Str) {
    var data = Buffer(base64Str, 'base64').toString();
    
    let decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8)

}
